module.exports = __webpack_public_path__ + "img/mt_bg.9662d954.png";